module.exports = __webpack_public_path__ + "img/jp.3d52ec29.png";